import { TripLegDetailsApiModel } from './trip-leg-details.api-model';
import { TicketSuggestionApiModel } from './ticket-suggestion.api-model';
import { LinkDetailsApiModel } from './link-details.api-model';
import { TicketSuggestionsResultApiModel } from './ticket-suggestions-result.api-model';
import type { IJourneyDetails } from '../../../../models/journey-details.model';
import { TariffZoneApiModel } from './tariff-zone.api-model';
import { ConnectionLinkApiModel } from '../journeys/connection-link.api-model';

export class JourneyDetailsApiModel {
  public static mapToBusinessModel(apiModel: JourneyDetailsApiModel): IJourneyDetails {
    return {
      departureAccessLink: LinkDetailsApiModel.mapToBusinessModel(apiModel.departureAccessLink),
      tripLegs: apiModel.tripLegs ? apiModel.tripLegs.map(TripLegDetailsApiModel.mapToBusinessModel) : undefined,
      arrivalAccessLink: LinkDetailsApiModel.mapToBusinessModel(apiModel.arrivalAccessLink),
      ticketSuggestions:
        apiModel.ticketSuggestionsResult?.ticketSuggestions && !apiModel.ticketSuggestionsResult.hasError
          ? apiModel.ticketSuggestionsResult.ticketSuggestions.map(TicketSuggestionApiModel.mapToBusinessModel)
          : undefined,
      destinationLink: LinkDetailsApiModel.mapToBusinessModel(apiModel.destinationLink),
      tariffZones: apiModel.tariffZones ? apiModel.tariffZones.map((tariffZone) => TariffZoneApiModel.mapToBusinessModel(tariffZone)) : undefined,
      connectionLinks: apiModel.connectionLinks ? apiModel.connectionLinks.map(ConnectionLinkApiModel.mapToBusinessDetailsModel) : undefined,
    };
  }

  public tripLegs!: TripLegDetailsApiModel[];
  public ticketSuggestionsResult?: TicketSuggestionsResultApiModel;
  public departureAccessLink?: LinkDetailsApiModel;
  public arrivalAccessLink?: LinkDetailsApiModel;
  public destinationLink?: LinkDetailsApiModel;
  public tariffZones!: TariffZoneApiModel[];
  public connectionLinks!: ConnectionLinkApiModel[];
}
